import { CouldNotParse } from 'components/ordering/checkout/payment-methods/payment-backend/could-not-parse.js'
import { is } from 'typia'
import { CSCOverrulePaymentMethod, OverrulePaymentMethodData } from './overrule.js'


type OverrulePaymentMethodResponse = OverrulePaymentMethodData & {
  type_: 'cloudsuite_overrule'
}

export const parseOverrulePaymentMethod = (
  value: unknown,
  selectedPaymentMethod: string
): CSCOverrulePaymentMethod | typeof CouldNotParse => {
  if (is<OverrulePaymentMethodResponse>(value)) {
    const state = value.ident === selectedPaymentMethod ? 'selected' : 'selectable'
    return new CSCOverrulePaymentMethod(value, state)
  }
  return CouldNotParse
}
